import axios from 'axios';

const httpClient = axios.create({
	baseURL: '/apps2/classtender'
});

export default {
	captcha() {
		return httpClient.get('/captcha');
	},
	submit(params, files) {
		const formData = new FormData();
		const requestJson = JSON.stringify(params);
		const requestBlob = new Blob([requestJson], {
			type: 'application/json'
		});
		files.forEach((file) => {
			formData.append('files', file);
		});
		formData.append('request', requestBlob);
		return httpClient.post('/submit', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
	}
};
